import { useMemo } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useI18n } from '../i18n';

export default function UsersTable({ rows, loading }) {
  const { t, fmtFullDateTime, lang } = useI18n();

  const columns = useMemo(() => [
    { field: 'username', headerName: t('usersTable.username'), flex: 1, minWidth: 150 },
    { field: 'email', headerName: t('usersTable.email'), flex: 2, minWidth: 200 },
    { field: 'role_name', headerName: t('usersTable.role'), flex: 1, minWidth: 130 },
    {
      field: 'last_login',
      headerName: t('usersTable.lastLogin'),
      flex: 1,
      minWidth: 160,
      renderCell: ({ value }) => fmtFullDateTime(value),
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
  ], [lang]);

  return (
    <DataGrid
      rows={rows}
      columns={columns}
      getRowId={(row) => row.user_id}
      loading={loading}
      autoHeight
      pageSizeOptions={[10, 25, 50]}
      initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
    />
  );
}
